import { useCallback, useEffect, useRef } from 'react';
import isFunction from 'transmute/isFunction';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { usePopoverClickListener } from '../hooks/usePopoverClickListener';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateActivityPopover = ({
  children,
  closeOnOutsideClick = true,
  content,
  interactionName,
  isOverflow = false,
  onPopoverToggle,
  open
}) => {
  const listElem = useRef(null);
  useEffect(() => {
    listElem.current = document.getElementById('overflow-activities-list');
  }, []);
  const handleToggleCallPopover = useCallback(specificToggleAction => {
    const {
      targetState
    } = specificToggleAction || {};
    const nextOpenState = targetState !== undefined ? targetState : !open;
    if (isFunction(onPopoverToggle)) {
      onPopoverToggle(nextOpenState);
    }
  }, [onPopoverToggle, open]);
  const handlePopoverOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    handleToggleCallPopover({
      targetState: value
    });
  }, [handleToggleCallPopover]);
  const handlePopoverClose = () => {
    handleToggleCallPopover({
      targetState: false
    });
  };
  const contentRef = useRef(null);
  usePopoverClickListener({
    contentRef,
    onClose: handlePopoverClose
  });
  const getPopoverPlacement = () => {
    if (interactionName === 'overflow') {
      return 'top';
    }
    if (isOverflow) {
      return 'right';
    }
    return 'bottom right';
  };
  const renderedPopover = /*#__PURE__*/_jsx(Popover, {
    "data-selenium-test": `${interactionName}-selectors-menu-popover`,
    open: open,
    closeOnOutsideClick: closeOnOutsideClick,
    onOpenChange: handlePopoverOpenChange,
    content: content,
    placement: getPopoverPlacement(),
    children: children
  }, interactionName);
  if (isOverflow) {
    return /*#__PURE__*/_jsx(IntersectionObserver, {
      root: listElem.current,
      threshold: 0.5,
      onIntersectionChange: ({
        entries
      }) => {
        if (!entries[0].isIntersecting) {
          handlePopoverClose();
        }
      },
      renderContent: () => renderedPopover
    });
  }
  return /*#__PURE__*/_jsx("div", {
    ref: contentRef,
    children: renderedPopover
  });
};
export default CreateActivityPopover;